package com.havn.app.features.auth.data

class HavnAuthCancelledException : RuntimeException("Sign-in cancelled.")

fun Throwable.isHavnAuthCancellation(): Boolean =
    this is HavnAuthCancelledException ||
        message?.contains("cancel", ignoreCase = true) == true ||
        message?.contains("AuthorizationError error 1001", ignoreCase = true) == true
